// src/components/rector/EnviarComunicado.jsx
import React, { useState } from 'react';
import axios from 'axios';
import socket from '../../socket';
import { useAuth } from '../../context/AuthContext';
import ListaComunicadosRector from '../../pages/ListaComunicadosRector';
import '../../style/App.css';

const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";

function EnviarComunicado() {
  const { token, user } = useAuth();

  const [titulo, setTitulo] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [destinatario, setDestinatario] = useState('todos');
  const [msg, setMsg] = useState('');
  const [mostrarLista, setMostrarLista] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');

    if (!user || !token) {
      setMsg('❌ Debes iniciar sesión correctamente.');
      return;
    }

    try {
      const payload = {
        titulo,
        mensaje,
        destinatario,

        // 🔹 MULTITENANCY AUTOMÁTICO
        tenant_id: user.tenant_id,
        sede_id: user.sede_id,

        // 🔹 Datos del remitente
        autor_id: user.id,
        creado_por: user.id
      };

      const { data } = await axios.post(`${API}/comunicados`, payload, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      // 🔹 Enviar por websocket
      socket.emit('enviarComunicado', data.comunicado);

      setMsg('✅ Comunicado enviado correctamente');
      setTitulo('');
      setMensaje('');
      setDestinatario('todos');

    } catch (err) {
      console.error(err);
      setMsg(err.response?.data?.message || '❌ Error al enviar el comunicado');
    }
  };

  return (
    <div className="form-wrapper">
      <h2>📢 Enviar Comunicado</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Título del comunicado"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
          required
        />

        <textarea
          placeholder="Escribe el mensaje..."
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          rows={5}
          required
        ></textarea>

        <label>¿A quién va dirigido?</label>
        <select
          value={destinatario}
          onChange={(e) => setDestinatario(e.target.value)}
        >
          <option value="todos">Todos</option>
          <option value="estudiantes">Estudiantes</option>
          <option value="padres">Padres</option>
          <option value="profesores">Profesores</option>
          <option value="secretaria">Secretaría</option>
        </select>

        <button type="submit">📨 Enviar Comunicado</button>
        {msg && <p className="status-msg">{msg}</p>}
      </form>

      {/* SOLO EL RECTOR VE EL HISTORIAL */}
      {user?.role === 'rector' && (
        <>
          <button
            onClick={() => setMostrarLista(!mostrarLista)}
            style={{ marginTop: 20 }}
          >
            {mostrarLista ? '🔽 Ocultar Historial' : '📜 Ver Historial'}
          </button>

          {mostrarLista && <ListaComunicadosRector />}
        </>
      )}
    </div>
  );
}

export default EnviarComunicado;
